import profileIcon from '../assets/images/profile.png';
import profileIcon2x from '../assets/images/profile@2x.png';

export function getLookerGroupIds(user) {
  return user.lookerGroupIds.map(i => parseInt(i, 10));
}

export function toJson(user) {
  return Object.assign({}, user, { lookerGroupIds: getLookerGroupIds(user) });
}

export const getClientLogo = (organizationName, size = '100x100') =>
  `https://tvtime-web-static-assets.s3-eu-west-1.amazonaws.com/images/${organizationName.replace(
    /\s/g,
    ''
  )}_${size}.png`;

export const fallbackImgFunc = e => {
  e.target.onerror = null;
  e.target.src = profileIcon;
  e.target.srcSet = `${profileIcon}, ${profileIcon2x} 2x`;
};

export default { toJson, getLookerGroupIds, getClientLogo, fallbackImgFunc };
